import { createTheme } from '@mui/material/styles'

const theme = createTheme({
  palette: {
    primary: {
      main: '#01788C',
      light: '#43B1C4',
      dark: '#004751',
      contrastText: '#FFFFFF',
    },
    text: {
      primary: '#000000de',
      secondary: '#00000099',
      disabled: '#00000061',
    },
    background: {
      default: '#ffffff',
      paper: '#fafafa',
    },
    action: {
      hover: '#01697B0D',
      selected: '#01697B14',
      focus: '#01697B1F',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          margin: 0,
          padding: 0,
          overflow: 'auto',
        },
      },
    },
  },
})

export default theme
